import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Select, Skeleton } from '@/components/ui/daisy';
import useCoursePathVersions from '@/data/hook/ped-content/useCoursePathVersions';
import getFormatedCoursePathVersion from '@/utils/shared/getFormatedCoursePathVersion';

export default function CoursePathVersionSelect() {
  const { versions, selectedSlug, changeVersion, isLoading } =
    useCoursePathVersions();

  if (isLoading) {
    return (
      <Skeleton
        data-testid="versionSelectSkeleton"
        className="w-25 h-6 rounded-md"
      />
    );
  }
  return (
    <ConditionalRenderer condition={!!versions.length}>
      <Select
        size="xs"
        value={selectedSlug ?? ''}
        onChange={event => changeVersion(event.target.value)}
      >
        {versions.map(coursePath => (
          <Select.Option key={coursePath.id} value={coursePath.slug}>
            {getFormatedCoursePathVersion({ coursePath })}
          </Select.Option>
        ))}
      </Select>
    </ConditionalRenderer>
  );
}
